<template>
  <div>
    <!-- Inline -->
    <div class="row q-mb-md">
      <!-- Filters hide/show button -->
      <div class="col-6">
        <div class="row" style="justify-content: flex-start">
          <div>
            <q-btn
              @click="hideFilters = !hideFilters"
              :text-color="hideFilters ? 'grey-5' : 'white'"
              class="neutral-btn ctrl-button btn-compact"
              :class="{ primary: !hideFilters }"
              icon="filter_list"
              :icon-right="
                hideFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
              "
            />
          </div>
          <!-- General searchfield -->
          <div class="q-ml-md" style="flex-grow: 1">
            <q-input
              color="grey-5"
              :disable="!hideFilters"
              v-model="searchTerm"
              @input="applyFilters"
              :placeholder="getString('module.logs.list.filter.label')"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Filters block -->
    <transition name="fade">
      <div v-if="!hideFilters" class="table-block q-mb-md">
        <div
          class="row q-pt-md q-pl-md q-pr-md"
          style="justify-content: space-between"
        >
          <!-- Select field -->
          <div class="col-6 q-pb-md q-pl-md q-pr-md">
            <q-select
              multiple
              @input="applyFilters"
              v-model="filters.level"
              :options="levelOptions"
              :float-label="getString('module.logs.list.table.column.level')"
            />
          </div>
          <!-- Inputfield -->
          <div class="col-6 q-pl-md q-pr-md">
            <q-input
              color="primary"
              v-model="filters.name"
              @input="applyFilters"
              :float-label="getString('module.spare-parts.field.pdfName')"
            />
          </div>
        </div>
        <!-- Button to reset fields -->
        <div class="row q-pl-md q-pr-md" style="justify-content: flex-end">
          <div class="q-pl-md q-pr-md q-pb-md" style="vertical-align: middle">
            <q-btn
              :disable="!activeFilters"
              @click="resetFilters()"
              class="capitalize ctrl-button"
              :color="activeFilters ? 'primary' : 'grey-4'"
              label="Reset"
            />
          </div>
        </div>
      </div>
    </transition>

    <!-- Data table -->
    <table-overview
      v-if="responseData.multiple"
      :endpoint="endpoint"
      :responseFormat="responseFormat"
      :columns="columns"
      :permission="permission"
      :module="module"
      :selectable="selectable"
      :highlight-fields="highlightFields"
    >
    </table-overview>
  </div>
</template>

<script>
import TableOverview from '@/components/overview/TableOverview.vue';
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';
import common from './common';

export default {
  mixins: [common, filtersMixin],
  components: {
    TableOverview,
  },
  data() {
    return {
      highlightFields: ['message'],
      rowSelection: [],
      isLoading: false,
      searchTerm: '',
      filters: {
        level: [],
        name: '',
      },
      levelOptions: [
        {
          label: 'Message',
          value: 'message',
        },
        {
          label: 'Warning',
          value: 'warning',
        },
        {
          label: 'Error',
          value: 'error',
        },
      ],
      columns: [
        {
          name: '__slot:level',
          title: this.getString('module.logs.list.table.column.level'),
          sortField: 'level',
          titleClass: 'text-left sortable vcol-xs',
          dataClass: 'text-left vcol-xs text-ellipsis',
        },
        {
          name: '__slot:spareparts-name',
          title: this.getString('module.spare-parts.field.pdfName'),
          titleClass: 'text-left sortable vcol-s',
          dataClass: 'text-left vcol-s text-ellipsis',
        },
        {
          name: '__slot:message',
          title: this.getString('module.logs.list.table.column.message'),
          sortField: 'message',
          titleClass: 'text-left sortable vcol-l',
          dataClass: 'text-left vcol-l text-ellipsis',
        },
        {
          name: 'updated_at.date',
          title: 'Timestamps',
          sortField: 'updated_at',
          titleClass: 'text-left sortable vcol-xs',
          dataClass: 'text-left vcol-xs text-ellipsis',
          callback: 'tableFormatTime',
        },
      ],
      hideFilters: true,
      preferences: {
        page: 1,
        perPage: 10,
        sortField: null,
        sortOrder: null,
      },
    };
  },
  methods: {
    getString,
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';
</style>
